import Pagination from 'rc-pagination'
import localeInfo from 'rc-pagination/lib/locale/en_US';
import Select from 'rc-select';
import 'rc-select/assets/index.less';
import Icon from '../Icon/Icon';
import './pagination.scss'
export default function IPagination({page,count,onPage,pageSize,onShowSizeChange}:{page:any,count:any,onPage:any,pageSize:any,onShowSizeChange:any}){
  return (
    <div className='pagination' >
      <Pagination 
        selectComponentClass={Select}
        onChange={onPage}
        current={page}
        total={count}
        pageSize={pageSize}
        prevIcon={() => <Icon token='arrow-left'/>}
        nextIcon={() => <Icon token='arrow-right'/>}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        locale={localeInfo}
        pageSizeOptions={['10', '20','30', '50']}
        />
    </div>
  )
}